<script setup lang="ts">
// types
import type { BlockTutorCardProps } from '@ts-blocks/block-tutor-card/interfaces'
// hooks
import { useBlockTutorCard } from '@hooks/blocks/block-tutor-card.hook'
// components
import { Button } from '@brighterly/lib-lumee-ui'
import { TutorProfile } from '@UI/Tutors/TutorProfile'
import { TutorQuote } from '@UI/Tutors/TutorQuote'

defineOptions({
  name: 'BlockTutorCard',
})

const props = defineProps<{
  block: BlockTutorCardProps
}>()

const {
  refCtaText,
  refCtaHref,
  refCtaTarget,
  handleClickCta,
} = useBlockTutorCard({
  block: () => props.block,
})
</script>

<template>
  <article class="block-tutor-card">
    <div class="block-tutor-card__content">
      <TutorProfile
        v-if="block.profile"
        :name="block.profile.name"
        :experience="block.profile.experience"
        :grades="block.profile.grades"
        :education="block.profile.education"
        :subjects="block.profile.subjects"
        :avatar="block.profile.avatar"
        :rating="block.profile.rating?.rating"
      />
      <TutorQuote
        v-if="block.quote?.quote"
        :quote="block.quote.quote"
      />
    </div>

    <a
      class="block-tutor-card__cta"
      :href="refCtaHref"
      :target="refCtaTarget"
      :rel="refCtaTarget === '_blank' ? 'noopener noreferrer' : undefined"
      @click="handleClickCta"
    >
      <Button
        view="primary"
        size="lg"
        trailing-icon="arrow-right"
        :text="refCtaText"
        tabindex="-1"
      />
    </a>
  </article>
</template>

<style scoped lang="scss" src="@scss/components/Blocks/BlockTutorCard.scss" />
